<template>
  <div>
    <div
      v-if="company && showCompany"
      class="media align-items-center mb-3"
    >
      <img
        class="rounded-circle user-image border mr-2"
        :src="getPhoto(company.logo,'thumbnailCropped')"
        alt=""
        style="width: 60px"
      >
      <div class="about">
        <div class="name f-w-600">
          {{ company.name }} {{ getCompanyFormat(company.format) }}
        </div>
        <div class="status">
          {{ company.taxId }}
        </div>
      </div>
    </div>

    <div v-if="['SUPPLIER','PROCUREMENT'].indexOf(profileType)>-1">
      <h4>{{ $t('companyRateStatistics.biznesReytinqi') }}</h4>
      <p v-if="profileType==='SUPPLIER'">
        {{ $t('companyRateStatistics.tdarkProfiliZrBiznesReytinqiTklifEdilnMalVXidmtlrZ') }}
      </p>
      <p v-else-if="profileType==='PROCUREMENT'">
        {{ $t('companyRateStatistics.satnalamaProfiliZrBiznesReytinqiAllarZamanTdarklrT') }}
      </p>


      <div class="row">
        <div class="col-7">
          <div
            v-for="n in 5"
            :key="n"
          >
            <span
              v-for="x in 5"
              :key="x"
              class="d-inline-block"
            >
              <i
                v-if="6-n >= x"
                class="fa fa-2x fa-star text-warning"
              />
              <i
                v-else
                class="fa fa-2x fa-star-o text-secondary"
              />
            </span>
            <a
              v-if="statisticMap[6-n] || 0 > 0"
              href="#"
              class="ml-5 lead"
              @click.prevent="showRatings =6-n"
            >
              <u>{{ $t('companyRateStatistics.ss', {expr: statisticMap[6 - n] || 0}) }}</u>
            </a>
            <span
              v-else
              class="ml-5 lead"
            >{{ $t('companyRateStatistics.ss', {expr: statisticMap[6 - n] || 0}) }}</span>
          </div>
        </div>
        <div class="col-5">
          <div class="text-center">
            <div
              v-if="myRate>0"
              class="display-2"
            >
              {{ myRate.toFixed(1) }}
            </div>
            <div
              v-else
              class="display-2"
            >
              -
            </div>
            <div class="small">
              {{ $t('companyRateStatistics.mnimBuIrktVerdiyim') }} <strong>{{ getProfileName(profileType) }}</strong>
              {{ $t('companyRateStatistics.reytinqi') }}
            </div>
          </div>
        </div>
      </div>


      <div
        v-if="showRatings>0"
        class="mt-4"
      >
        <div v-if="ratingList.length<1">
          <div class="alert alert-info">
            {{ $t('companyRateStatistics.axtaraUyunNticTaplmad') }}
          </div>
        </div>

        <div class="v-else">
          <div
            v-for="r in ratingList"
            :key="r.id"
          >
            <div class="card ">
              <div class="card-body p-2">
                <div class="media">
                  <img
                    class="img-50 img-fluid m-r-20 rounded-circle"
                    alt=""
                    :src="getPhoto(r.user.photo,'thumbnailCropped')"
                  >
                  <div class="media-body bg-white">
                    <div class="d-flex justify-content-between align-items-top mb-3">
                      <span>
                        <span class="f-w-600">{{ r.user.name }} {{ r.user.surname }}</span> <br>
                        <span class="text-primary small">
                          {{ r.company.name }} {{
                            getCompanyFormat(r.company.format)
                          }}
                          ({{ r.position }})
                        </span>
                      </span>
                      <em class="text-secondary">
                        {{ $t('dashboardCompany.key', {moment: getMoment(r.logTime)}) }}
                      </em>
                    </div>

                    <div>
                      <span
                        v-for="x in 5"
                        :key="x"
                        class="d-inline-block"
                      >
                        <i
                          v-if="r.rate >= x"
                          class="fa fa-star text-warning"
                          aria-hidden="true"
                        />
                        <i
                          v-else
                          class="fa fa-star-o text-secondary"
                          aria-hidden="true"
                        />
                      </span>
                    </div>

                    <div style="white-space: pre-wrap">
                      {{ r.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr>
    </div>
    <h4>{{ $t('companyRateStatistics.aktivlikReytinqi') }}</h4>
    <p>
      {{ $t('companyRateStatistics.irktinHrBirProfiliZrAktivlikDrcsiHminProfilZrFaliy') }}
    </p>


    <div v-if="profileType==='PROCUREMENT'">
      <p v-if="createMap['RFQ']">
        <i class="fa fa-check-square text-success mr-2" />
        <strong>{{ $t('companyRateStatistics.createmaprfqRfqSorusuYaradlbVPurchasemaprfq0AlBaTu', {create:createMap['RFQ'], purchase:purchaseMap['RFQ']}) }}</strong>
      </p>
      <p v-if="createMap['REV']">
        <i class="fa fa-check-square text-success mr-2" /> <strong>{{
          $t('companyRateStatistics.createmaprevKsHrracYaradlbVPurchasemaprev0AlBaTutu', {
            create: createMap['REV'],
            purchase1: purchaseMap['REV']
          })
        }}</strong>
      </p>
      <p v-if="purchaseMap['RFI']">
        <i class="fa fa-check-square text-success mr-2" /> <strong>{{
          $t('companyRateStatistics.rfiSorularndanPurchasemaprfi0AlBaTutub', {purchase: purchaseMap['RFI']})
        }}</strong>
      </p>
      <hr>
    </div>

    <div v-if="profileType==='SUPPLIER'">
      <p v-if="offersMap['RFQ']">
        <i class="fa fa-check-square text-success mr-2" /> <strong>{{
          $t('companyRateStatistics.offersmaprfqRfqSorusunaTklifGndrilibVSalesmaprfq0S', {
            offerMap: offersMap['RFQ'],
            salesMap: salesMap['RFQ'] || 0
          })
        }}</strong>
      </p>
      <p v-if="offersMap['REV']">
        <i class="fa fa-check-square text-success mr-2" /> <strong>{{
          $t('companyRateStatistics.offersmaprevKsHrracaTklifGndrilibVSalesmaprev0SatB', {
            offerMap: offersMap['REV'],
            salesMap: salesMap['REV'] || 0
          })
        }}</strong>
      </p>
      <p v-if="salesMap['RFI']">
        <i class="fa fa-check-square text-success mr-2" /> <strong>
          {{ $t('companyRateStatistics.rfiSorularndaSalesmaprfi0SatBaTutub', {sales: salesMap['RFI']}) }}</strong>
      </p>
      <hr>
    </div>


    <div class="row mt-3">
      <div class="col-md-6">
        <strong>{{ $t('companyRateStatistics.soruYaratmaStatistikas') }}</strong>
        <div>
          <div
            v-for="s in companyActivityRatingList"
            class="row my-2"
          >
            <div class="col-md-6">
              <strong>{{ s.keyword }}</strong>
            </div>
            <div class="col-md-6">
              {{ s.counter }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-center">
        <div class="display-2">
          <div :class="[companyActivityRating<0?'text-danger':'text-success']">
            {{ companyActivityRating || '-' }}
          </div>
        </div>
        <p class="lead">
          {{ $t('companyRateStatistics.mkda', {companyActivityUserCount: companyActivityUserCount}) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCompanyActivityStatistics,
  getCompanyRatingList,
  getCompanyRatingStatistics
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import moment from "moment";

export default {
  name: 'CompanyRateStatistics',
  props: {
    companyId: {
      type: Number,
      default: 0
    },
    profileType: {
      type: String,
      default: 'SUPPLIER'
    },
    showCompany: {
      type: Boolean,
      default: false
    }
  },
  data() {

    return {
      companyStats: [],
      myRate: 0,

      showRatings: 0,
      ratingList: [],
      company: null,
      companyActivityRatingList: [],
      companyActivityRating: 0,
      companyActivityUserCount: 0,
      companyOffer: [],
      companySales: [],
      companyPurchases: [],
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token
    }),
    statisticMap() {

      let map = {};

      this.companyStats.forEach(s => {
        map[s.rate] = s.rateCount;
      })

      return map;

    },
    createMap() {
      let map = {};
      this.companyActivityRatingList.forEach(s => {
        map[s.keyword] = s.counter;
      })
      return map;
    },
    offersMap() {
      let map = {};
      this.companyOffer.forEach(s => {
        map[s.keyword] = s.counter;
      })
      return map;
    },
    salesMap() {
      let map = {};
      this.companySales.forEach(s => {
        map[s.keyword] = s.counter;
      })
      return map;
    },
    purchaseMap() {
      let map = {};
      this.companyPurchases.forEach(s => {
        map[s.keyword] = s.counter;
      })
      return map;
    }

  },
  watch: {
    companyId() {
      this.loadStatistics();
    },
    profileType() {
      this.showRatings = 0;
      this.loadStatistics();
    },
    showRatings(newVal) {
      if (newVal < 1) {
        this.ratingList = [];
      } else {
        this.loadRatingList();
      }
    }
  },

  mounted() {

    this.loadStatistics();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    loadStatistics() {
      getCompanyRatingStatistics(this.token, this.companyId, this.profileType).then(data => {
        this.companyStats = data.statistics;
        this.myRate = data.myRate;
        this.company = data.company;
      })


      getCompanyActivityStatistics(this.token, this.companyId, this.profileType).then(d => {
        if (d.code === 200) {
          this.companyActivityRatingList = d.rating;
          this.companyActivityRating = d.totalPoint;
          this.companyActivityUserCount = d.userCount;
          this.companySales = d.sales;
          this.companyOffer = d.offers;
          this.companyPurchases = d.purchases;
        }
      })
    },
    loadRatingList() {
      getCompanyRatingList(this.token, this.companyId, this.profileType, this.showRatings).then(list => {
        this.ratingList = list;
      })

    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
  }

}
</script>
